import { menuConfig } from "./menuConfig";

export const getFirstAllowedRoute = (
  permissions: Record<string, Record<string, boolean>>
) => {
  const firstAllowed = menuConfig.find(item =>
    permissions[item.permission.module]?.[item.permission.action.toLowerCase()]
  );

  return firstAllowed?.path || "/unauthorized";
};
